<template>
  <q-dialog v-model="openSync" @before-show="loadUsers">
    <q-card style="width: 700px; max-width: 80vw">
      <q-card-section>
        <h5>Users</h5>
      </q-card-section>

      <q-card-section style="height: 50vh" class="scroll">
        <data-table :columns="columns">
          <template v-if="loading">
            <tr v-for="n in 10" :key="n">
              <td v-for="m in columns.length" :key="m">
                <q-skeleton type="text" />
              </td>
            </tr>
          </template>

          <template v-else-if="!users.length">
            <tr>
              <td :colspan="columns.length">
                <div class="text-center text-h6">
                  <span>No records found.</span>
                </div>
              </td>
            </tr>
          </template>

          <tr v-for="user in users" v-else :key="user.id">
            <td>
              <span v-if="user.name">
                <b>{{ user.name }}</b>
                <br />
              </span>
              <span>{{ user.email }}</span>
            </td>
            <td>{{ user.role | capitalize }}</td>
            <td>
              <span v-if="user.lastLoginAt">{{ user.lastLoginAt | formatDateTime }}</span>
              <span v-else>Invitation sent</span>
            </td>
          </tr>
        </data-table>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
import { getErrorMessage } from '@/utils';
import DataTable from '@/components/DataTableNew.vue';
import formatDateMixin from '@/utils/mixins/formatDateMixin';

export default {
  components: { DataTable },
  mixins: [formatDateMixin],
  props: {
    open: {
      type: Boolean,
      required: true,
    },
    transporterId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      loading: false,
      error: '',
      users: [],
      columns: ['User', 'Role', 'Last Login'],
    };
  },

  computed: {
    openSync: {
      get() {
        return this.open;
      },

      set(value) {
        this.$emit('update:open', value);
      },
    },
  },

  methods: {
    async loadUsers() {
      try {
        this.error = '';
        this.loading = true;

        const { data } = await this.$axios.get(`/admin/transporter/${this.transporterId}/users`);
        this.users = data;
      } catch (error) {
        this.error = getErrorMessage(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style></style>
